import { render, staticRenderFns } from "./HotelUninvoiced.vue?vue&type=template&id=4978ebe5&"
import script from "./HotelUninvoiced.vue?vue&type=script&lang=js&"
export * from "./HotelUninvoiced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports